import { msalConfig } from '../auth-config';
import { PublicClientApplication } from "@azure/msal-browser";
import { PROVIDER_APP_ID } from './environment';

// @ts-ignore
const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsal = async () => {
    await msalInstance.initialize();
    console.log("MSAL initialized successfully - ", window.location.pathname);
};

const handleRedirectResponse = async () => {
    const authResult = await msalInstance.handleRedirectPromise();
    if (authResult) {
        const account = msalInstance.getActiveAccount();
        if (!account) {
            msalInstance.setActiveAccount(authResult.account);
        }
    }
};

const acquireTokenSilent = async (account: any) => {
    const accessTokenRequest = {
        scopes: [`api://${PROVIDER_APP_ID}/.default`],
        account,
    };
    const accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return accessTokenResponse.accessToken;
};

export const retrieveAccessToken = async (handleLogin: (() => Promise<void>) | null) => {
        await initializeMsal();
        await handleRedirectResponse();

        const accounts = msalInstance.getAllAccounts();
        if (accounts && accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
            return await acquireTokenSilent(accounts[0]);
        } else {
            console.warn("No accounts found. Initiating login.");
            if(handleLogin){
                await handleLogin();
            }else{
                window.location.reload(); // Reload the page
            }
        }
};